import { render } from "./TrixField.vue?vue&type=template&id=b89e0b9a"
import script from "./TrixField.vue?vue&type=script&lang=js"
export * from "./TrixField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TrixField.vue"]])

export default __exports__